import { DataModel } from "../../base/index.js";
import type { HandleReadableData } from "./types.js";
import { DomainHandle } from "../DomainHandle/index.js";

export class DomainHandleReadable extends DataModel<HandleReadableData> {
  public current: DomainHandle;
  public desired?: DomainHandle;
  public constructor(data: HandleReadableData) {
    super(data);
    this.current = new DomainHandle(data.current);
    if (data.desired) {
      this.desired = new DomainHandle(data.desired);
    }
  }
}
